import { findNode } from './findNode.mjs';
import { isVoidNode } from './isVoidNode.mjs';

function hasVoidDescendant(editor, path) {
  const voidNode = findNode(editor, {
    at: path,
    match: node => isVoidNode(editor, node)
  });
  return voidNode != null;
}

export { hasVoidDescendant };
